import { UserLight, API as UserAPI, mapAPIToUserLight } from 'models/users';

import { API_URL } from 'config';
import { makeAPICall } from './api';

export declare namespace API {
    export interface Group {
        id: number;
        name: string;
    }

    export interface Organisation {
        id: number;
        name: string;
        users: UserAPI.UserLight[];
        role: string;
        description: string;
        address: string;
        primary_contact_email: string;
    }
}

export type Group =
    | 'Organisation Manager'
    | 'Ground Station Operator'
    | 'Satellite Operator';

export interface Organisation {
    id: number;
    name: string;
    users: UserLight[];
    role: string;
    description: string;
    address: string;
    primaryContactEmail: string;
}

const ORGANISATIONS_ROUTE = '/organisations';

export const mapAPIToOrganisation = ({
    users,
    primary_contact_email,
    ...rest
}: API.Organisation): Organisation => ({
    ...rest,
    users: users.map((user) => mapAPIToUserLight(user)),
    primaryContactEmail: primary_contact_email,
});

export const listOrganisations = makeAPICall<
    Organisation[],
    void,
    { results: API.Organisation[] }
>(
    () => ({
        url: `${API_URL}${ORGANISATIONS_ROUTE}/`,
    }),
    (data) => data.results.map(mapAPIToOrganisation),
);

export const getOrganisationById = makeAPICall<
    Organisation,
    { id: number },
    API.Organisation
>(
    ({ id }) => ({
        url: `${API_URL}${ORGANISATIONS_ROUTE}/${id}/`,
    }),
    (satellite) => mapAPIToOrganisation(satellite),
);
